/** iPhone/iPad/iPod; iPadOS reports a Mac UA, told apart by touch points. */
export const IS_IOS: boolean =
  typeof navigator !== 'undefined' &&
  (/iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
